(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('[data-gz-slideshow]').forEach(function (root) {
  var mainImage = root.querySelector('[data-gz-main-image]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gz-thumb]'));
  if (!mainImage || thumbs.length === 0) return;

  var index = 0;

  function goTo(i) {
    index = (i + thumbs.length) % thumbs.length;
    var thumb = thumbs[index];
    mainImage.src = thumb.dataset.src;
    mainImage.alt = thumb.dataset.alt;
    thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
  }

  var prevBtn = root.querySelector('[data-gz-prev]');
  var nextBtn = root.querySelector('[data-gz-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { goTo(parseInt(thumb.dataset.gzThumb, 10)); });
  });

  var mainBox = root.querySelector('.gz-slide-main');
  var startX = null;
  mainBox.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  mainBox.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var diff = e.changedTouches[0].clientX - startX;
    if (diff > 40) goTo(index - 1);
    else if (diff < -40) goTo(index + 1);
    startX = null;
  });
});

  } catch(e) { console.error(e); }
})();
})();
